// SurveyFormHeader.js
import React from 'react';
import { ReactComponent as Logo } from "../Assets/linz.svg";
import { ReactComponent as RedoIcon } from "../Assets/redo.svg";
import { ReactComponent as PrintIcon } from "../Assets/print.svg";

const SurveyFormHeader = ({ title, onReset, onPrint, isOptionSelected }) => {
  return (
    <div className="flex flex-row max-w-[700px] print:m-auto">
      <div className="basis-full mt-0 mb-2 grid grid-flow-row items-end">
        <h2 id="print-title" className="text-4xl font-semibold">{title}</h2>
      </div>
      <div className="w-[277px] mb-2">
        <Logo id="linz-logo" title="LINZ" />
      </div>
      <div
        id="calulator-buttons"
        className="grid grid-cols-1 grid-flow-col auto-cols-auto content-end gap-2 mb-2 min-w-fit"
      >
        <button
          onClick={onReset}
          className="px-2 py-1 pr-3 border border-lui-sea rounded text-lui-sea hover:bg-lui-iceberg grid grid-cols-1 grid-flow-col"
        >
          <RedoIcon width={24} className="antialiased stroke-none fill-lui-sea" /><span className="font-semibold">&nbsp;Reset</span>
        </button>
        <button
          onClick={onPrint}
          disabled={!isOptionSelected}
          className="px-2 py-1 pr-3 bg-lui-sea font-semibold text-white border border-lui-sea rounded hover:bg-lui-teal disabled:text-lui-gray disabled:bg-lui-lily disabled:hover:bg-lui-lily disabled:border-lui-gray disabled:cursor-not-allowed order-last grid grid-cols-1 grid-flow-col"
        >
          <PrintIcon width={24} className={ "antialiased " + (isOptionSelected ? "stroke-none fill-white" : "stroke-none fill-lui-gray") } /><span className="font-semibold">&nbsp;Print</span>
        </button>
      </div>
    </div>
  );
};

export default SurveyFormHeader;
